import styled from "styled-components";

import { LocalStackOrder, T_PLAIN_small } from "../../../global.style";
import { TOP_PADDING } from "../../header/Header.styles";

export const StyledVariantVersionWrapper = styled.div `
    padding-top: ${TOP_PADDING}px;
    margin-left: 18px;
`;

export const HeaderInfo = styled.div`
    flex-basis: 100%;
    display: flex;
    align-items: center;
`;

export const HeaderInfoText = styled.div<{ hasTooltip: boolean }>`
    margin-left: ${props => props.hasTooltip ? "5px" : "0"};
    ${T_PLAIN_small};
`;

export const StickySummaryBar = styled.div`
    position: sticky;
    box-sizing: content-box;
    top: 0;
    width: 100%;
    z-index: ${LocalStackOrder.AboveContent};
    background-color: ${props => props.theme.C_BG_floorplan};
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 10px 10px 24px;
    margin-left: -10px;
`;

